import { Component } from '@angular/core';

@Component({
    selector: 'app-verify-email',
    imports: [],
    templateUrl: './verify-email.component.html',
    styleUrl: './verify-email.component.scss'
})
export class VerifyEmailComponent {

}
